const translations = {
  "en": {
    "Chart": "Chart",
    "Other Assets": "Other Assets"
  },
  "zh-tw": {
    "Chart": "圖表",
    "Other Assets": "其他資產"
  }
};

export default translations;
